import { RequestService } from "../../../common/services/RequestService";
import { SEND_MESSAGE_FEEDBACK } from "../constants";

export const sendMessageRequest = async payload => {
  const data = {
    subject: payload.message,
    contact_me: payload.contact ? true : false,
    recaptcha_token: payload.token
  };

  if (data.contact_me) {
    data.phone_code = +payload.phoneCode;
    data.phone = payload.phone;
    data.email = payload.email;
  }

  const response = await RequestService.post(SEND_MESSAGE_FEEDBACK, data);

  return response && response.data;
};
